module.exports = __webpack_public_path__ + "img/s2P34.e46d0780.png";